export default __webpack_public_path__ + "static/char-v-37-zh-Hant-6a7d7a801027284b7acf828a8b3bc720.mp4";